import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort, MatTableDataSource, MatSelectChange } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as XLSXStyle from 'xlsx-style';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
import { generalService } from '../../../services/general.service';
import { DataService } from '../../../utils/data.service';
import { DataSourceGrid } from '../../../utils/data-source-grid.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { destroyView } from '@angular/core/src/view/view';
import { ConciliacionExportData } from '../../../models/conciliacion-export-data-Cociliacion';

import { PdfExporterServiceConciliacion } from '../service/pdf-exporter.service';

@Component({
    selector: 'conciliacionBancaria-consultar',
    styleUrls: ['conciliacionBancaria-consultar.component.scss'], 
    templateUrl:'conciliacionBancaria-consultar.component.html',
    providers: [generalService,PdfExporterServiceConciliacion]
})

export class ConciliacionBancariaConsultarComponent implements OnInit{
    myForm: FormGroup;
    dataSource: DataSourceGrid | MatTableDataSource<any> | null = null;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild('tableDiot1') tableDiot1: ElementRef;
    displayedColumns = ['ACCIONES','CUENTABANCARIA','FECHACOCILIACION','STATUS'];
    public listBankAccount: any[] = [];
    public listBankConciliation: any[] = [];
    public listDateBankConciliation: any[] = [];
    public datosGeneralesSAE: any;
    public exportData: ConciliacionExportData = new ConciliacionExportData();
    private saleExportName = '';
    public hasDiscount: any;
    //Buscador Filtro 
    private arrayFiltered = undefined;
    private filteredItemsShow = 10;
    private isFiltered = false;
    private itemsShow = 10;
    public viewDataCuentas: any[];
    

    constructor(private formBuilder: FormBuilder,
        
        private pdfExporterServiceConciliacion: PdfExporterServiceConciliacion,
        private _generalService: generalService,
        private router:Router) {
        this.myForm = new FormGroup({});
    }

    ngOnInit() {
        this.buildForm();
        this.getDataBankAccount();
        this.consultar();
    }

    buildForm(){
        this.myForm = this.formBuilder.group({
            cuentaForm: [null],
            fechaConsiliacionForm: [null],
        }); 
    }

    getDataBankAccount(){
        let metodo = 'ConciliacionBancaria/getDataBankAccount';
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
        };

        this._generalService.metodoCallParams(params, metodo, true).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                if (tableResult && tableResult.Table) {
                    this.listBankAccount = tableResult.Table;
                    this.viewDataCuentas = this.listBankAccount;
                }
            }, 
            (error) => {
                console.log(error as any);
            }
        );
    }

    getBankConciliation(BANK_ACCOUNT_ID: number, DATE: any) {
        this.listBankConciliation = [];
        let metodo = 'ConciliacionBancaria/getListBankConciliation';
    
        const params = { 
            loacs: sessionStorage.getItem('acslo'),
            BANK_ACCOUNT_ID: BANK_ACCOUNT_ID,
            CONCILIATION_DATE: DATE
        };
    
        this._generalService.metodoCallParams(params, metodo, true).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                if (tableResult.Table.length > 0) {
                    this.listBankConciliation = tableResult.Table; 
                    this.dataSource = new DataSourceGrid(this.listBankConciliation, this.paginator, this.sort);
                } else {
                    this.listBankConciliation = []; 
                    this.dataSource = null;
                }
            }, 
            (error) => {
                console.log(error as any);
            }
        );
    }
    
    consultar() {
        let fechaActual = new Date();
        let fechaDosMesesMenos = new Date();
        fechaDosMesesMenos.setMonth(fechaActual.getMonth() - 2);
        
        let BANK_ACCOUNT_ID = this.myForm.controls['cuentaForm'].value ?? 0; 
        let filtroFecha = this.myForm.controls['fechaConsiliacionForm'].value ?? fechaDosMesesMenos; // Usar la fecha de hace dos meses si no hay valor
    
        // Llamar a la función para obtener la conciliación bancaria
        this.getBankConciliation(BANK_ACCOUNT_ID, filtroFecha);
    }
    
    
    onCuentaChange(event: MatSelectChange) {
        this.myForm.get('fechaConsiliacionForm')?.reset();
        let metodo = 'ConciliacionBancaria/getDateBankConcilition';
        const BANK_ACCOUNT_ID = event.value;
       
        const params = {
            loacs: sessionStorage.getItem('acslo'), 
            BANK_ACCOUNT_ID:BANK_ACCOUNT_ID,
        };

        this._generalService.metodoCallParams(params, metodo, true).subscribe(
            (result) => {
                const tableResult = JSON.parse(result);
                if (tableResult && tableResult.Table) {
                    this.listDateBankConciliation = tableResult.Table;                      
                }
            }, 
            (error) => {
                console.log(error as any);
            }
        );
    }

    onKeyUpProd(val: any) {
        let arr: any[];
        if (val.currentTarget.value != "") {
        this.arrayFiltered = this.listBankAccount.filter((obj) => {
            return obj.NAME.toLowerCase().indexOf(val.currentTarget.value.toLowerCase()) > -1;
        })

        arr = this.arrayFiltered.slice(0, this.filteredItemsShow);
        this.isFiltered = true;
        } else {
        /***************************INFINITE SELECT**********************************/
        // arr = this.filtroSATCodes;
        this.isFiltered = false;
        this.filteredItemsShow = 10;
        this.arrayFiltered = undefined;
        arr = this.listBankAccount.slice(0, this.itemsShow);
        /***************************INFINITE SELECT**********************************/
        }
        /***************************INFINITE SELECT**********************************/
        
            this.viewDataCuentas = arr;
        
        /***************************INFINITE SELECT**********************************/
    }
   
    exportPDF(BANK_CONCILIATION_ID: any) {
        this._generalService.requestGet("ConciliacionBancaria/GetSaleExportData?BANK_CONCILIATION_ID=" + BANK_CONCILIATION_ID).subscribe(
            (ExporDataSet) => {
                ExporDataSet = JSON.parse(ExporDataSet);
                this.exportData = this.generateSaleExportDataFromDataSet(ExporDataSet);    
    
                const date = new Date();
                const currentDay = date.getDate().toString().padStart(2, '0'); 
                const currentMonth = (date.getMonth() + 1).toString().padStart(2, '0'); 
                const currentYear = date.getFullYear();
    
                setTimeout(() => {
                    this.saleExportName = `Conciliación Bancaria_`+ExporDataSet.Table[0].CONCILIATION_NUMBER+" " + currentDay + "/" + currentMonth + "/" + currentYear;
                    this.pdfExporterServiceConciliacion.export(this.exportData, this.saleExportName, true);
                }, 300);
            }, 
            (error) => {
                console.error(error);
            }
        );
    }
    

     // ---------- FUNCIONES DE EXPORTACIÓN PDF ------------
     public generateSaleExportDataFromDataSet(ExporDataSet) {
        let exportData = new ConciliacionExportData();
        exportData.companyName = ExporDataSet.Table1[0];
        exportData.details =  ExporDataSet.Table;
        exportData.detailsPolizaEgresos =  ExporDataSet.Table2;
        exportData.detailsPolizaIngresos =  ExporDataSet.Table3;
        return exportData;
    }


}



// WEBPACK FOOTER //
// ./src/app/Contabilidad/conciliacionBancaria/consultar/conciliacionBancaria-consultar.component.ts